import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PeopleTimeZoneInfoSidebarProps as Props } from './types';
import { Chip, Stack, Typography } from '@mui/material';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { Icon } from '@aibees/shared/components';
import { findTimeZoneByLocationCountry } from '@aibees/elephant/utils';
import { useRecordLastUpdate } from '@aibees/elephant/hooks';

export const PeopleTimeZoneInfoSidebar = memo(({ className }: Props) => {
  const { api } = usePersonReadDataContext();
  const { lastUpdatePeople } = useRecordLastUpdate();
  const timeZone = findTimeZoneByLocationCountry(api?.data?.location?.country);
  const jobType =
    api?.data?.positionGroups?.[0]?.profile_positions?.[0]?.employment_type;

  if (!jobType && !timeZone) {
    return null;
  }

  return (
    <Styled.Wrapper
      className={classnames('PeopleTimeZoneInfoSidebar', className)}
      sx={SX.root}
    >
      <Stack direction="row" gap={1}>
        {jobType && (
          <Chip
            size="small"
            color="default"
            label=<Typography
              px={0.5}
              variant="body4"
              fontWeight={400}
              color="grey.600"
            >
              {jobType}
            </Typography>
            icon={<Icon name="clock" />}
          />
        )}
        {/* <Chip
          size="small"
          color="default"
          label=<Typography
            px={0.5}
            variant="body4"
            fontWeight={400}
            color="grey.600"
          >
            On-Site
          </Typography>
          icon={<Icon name="business-center" />}
        /> */}
        {timeZone && (
          <Chip
            size="small"
            color="default"
            label=<Typography
              px={0.5}
              variant="body4"
              fontWeight={400}
              color="grey.600"
            >
              {timeZone}
            </Typography>
            icon={<Icon name="timezone" />}
          />
        )}
      </Stack>
      <Stack direction="row" gap={1.25} alignItems="center">
        <Typography variant="body5" fontWeight={400} color="grey.500">
          Last Update:{' '}
          <Typography
            component="span"
            variant="body4"
            fontWeight={700}
            color="grey.700"
          >
            {lastUpdatePeople}
          </Typography>
        </Typography>
      </Stack>{' '}
    </Styled.Wrapper>
  );
});

PeopleTimeZoneInfoSidebar.displayName = 'PeopleTimeZoneInfoSidebar';
